import { css } from "styled-components";
import defaultTheme from "@material-ui/core/styles/defaultTheme";

const positionNavButton = css`
  position: fixed;
  margin-top: calc(100vh - 25vmin);
  margin-bottom: calc(50vh - 25vmin);
  max-width: 100%;
  max-height: 100%;

  ${[defaultTheme.breakpoints.down("sm")]} {
    margin-top: calc(100vh - 40vmin);
  }
`;

export default positionNavButton;
